import { useQuery } from '@src/shared/query';
import { selectActivityTypeGroups } from '../../lib';
import { typeGroupsUrl } from './constants';

export default function useActivityTypeGroups() {
  const { data: activityTypeGroups = [], ...restQuery } = useQuery(
    typeGroupsUrl,
    {
      select: selectActivityTypeGroups,
    },
  );

  return {
    activityTypeGroups,
    ...restQuery,
  };
}
